import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { StatusInputWrapper } from '../../../../shared/components/StatusInputWrapper'

const Name = ({ t, validateName, nameError, nameValid, setIsError }) => {
    const dispatch = useDispatch()
    const [isFocussed, SetIsFocussed] = useState(false)

    const name = useSelector((state) => state.app.contactInformation.name)


    const handleName = (e) => {
        try {
            let name = e.currentTarget.value.replace(/\d/g, "")
            dispatch(changeObjectPropertyAction('contactInformation', 'name', name))
            validateName(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    const onBlurName = (e) => {
        try {
            SetIsFocussed(false)
            let name = e.currentTarget.value.trim()
            dispatch(changeObjectPropertyAction('contactInformation', 'name', name))
            validateName(name)
        } catch (err) {
            console.log(err)
            setIsError(true)
        }
    }

    return (
        <StatusInputWrapper
            isValid={nameValid}
            errorMsg={nameError}
            t={t}
            label={t('contact_info.name')}
            customClasses={'fw-20'}
            id="Name" name="Name" type="text"
            aria-describedby="name"
            onChange={handleName}
            onBlur={onBlurName}
            onFocus={() => SetIsFocussed(true)}
            isFocussed={isFocussed}
            value={name}
            autoComplete="off"
            maxLength="150"
        />
    )
}

export default withTranslation('common')(Name)